
import { Component, Vue, Prop } from "vue-property-decorator";
const TemplateTransformTwo = () =>
  import("../template-transform/template-transform-two.vue");
@Component({
  components: {
    TemplateTransformTwo,
  },
})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private get c() {
    return this.data;
  }
  private clickDanbu(item: any) {
    console.log(item);
    this.c.options.forEach((option: any) => {
      if (item.name.includes(option.name)) {
        option.value = !option.value;
      } else {
        option.value = false;
      }
      if (option.content) {
        option.content = "";
        if (option.extra) {
          option.extra.forEach((ext: any) => {
            if (ext.type === "多选") {
              ext.value = [];
            } else {
              ext.value = "";
            }
          });
        }
      }
    });
  }
  private updateTemplate(item: any) {
    this.c.extra[item.index] = item.data;
  }
}
